// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.box_main {
    width: 100%;
    background-color: #ffffff;
    height: auto;
    padding: 20px;
    box-shadow: 0px 0 30px 10px #f0f0f0;
    margin-bottom: 20px;
}

.shirt_text {
    width: 100%;
    font-size: 20px;
    color: #30302e;
    text-align: center;
    font-weight: bold;
    padding-bottom: 5px;
}

.price_text {
    width: 100%;
    font-size: 16px;
    color: #EB8336;
    text-align: center;
    margin: 0px;
    font-weight: bold;
}

.tshirt_img {
    width: 100%;
    text-align: center;
    margin: 50px 0px;
    height: 250px;
}`, "",{"version":3,"sources":["webpack://./src/client/Components/Product/product.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,mCAAmC;IACnC,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB","sourcesContent":[".box_main {\n    width: 100%;\n    background-color: #ffffff;\n    height: auto;\n    padding: 20px;\n    box-shadow: 0px 0 30px 10px #f0f0f0;\n    margin-bottom: 20px;\n}\n\n.shirt_text {\n    width: 100%;\n    font-size: 20px;\n    color: #30302e;\n    text-align: center;\n    font-weight: bold;\n    padding-bottom: 5px;\n}\n\n.price_text {\n    width: 100%;\n    font-size: 16px;\n    color: #EB8336;\n    text-align: center;\n    margin: 0px;\n    font-weight: bold;\n}\n\n.tshirt_img {\n    width: 100%;\n    text-align: center;\n    margin: 50px 0px;\n    height: 250px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
